<template>
  <div :class="['steps', 'vue', { horizontal }, { vertical: !horizontal }]">
    <div class="step-info-wrapper">
      <template v-for="(step, i) in value">
        <div
          :key="step.value"
          class="step-info"
          :class="{ active: step.active, disabled: step.disabled || step.locked, success: step.completed }"
          @click="changeStep(step)"
        >
          <a
            :href="'javascript:void(0)'"
            :class="`${horizontal ? 'd-flex flex-column align-items-center' : ''} choose-step`"
            style="flex-direction: column"
            data-skip-check="true"
          >
            <div :class="['step-count', horizontal ? 'position-relative ml-0' : '', { locked: step.locked }]">
              <i v-if="step.locked" class="fas fa-lock" />
              <span v-else>{{ i + 1 }}</span>
            </div>
            <div v-if="!horizontal" class="step-description">{{ step.text }}</div>
            <strong v-if="horizontal" class="mt-3 bg-white z-3 px-3">{{ step.text }}</strong>
          </a>
        </div>
      </template>
    </div>
    <div class="step-connection" />
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

import { IStep } from '@/types/base'

@Component({
  name: 'sf-steps',
})
export default class SfSteps extends Vue {
  @Prop({ default: () => [] }) value!: IStep[]
  @Prop({ default: false }) horizontal!: boolean
  @Prop({ default: true }) updateURL!: boolean

  @Watch('$route')
  onRouteChange(): void {
    // This is to handle the case when the user changes the route manually through browser back/forward buttons.
    // This is also triggered when the route is changed programmatically.
    // And to prevent NavigationDuplication error we have a condition to check if the query is already the same inside changeStep method.
    const validSteps = this.value.filter((step) => step.value === this.$route.query['v-step'])
    if (validSteps.length === 1) {
      this.changeStep(validSteps[0])
    }
  }

  changeStep(step: IStep, initial?: boolean): void {
    // This method is only called when the user clicks on a steps or displayed buttons and not when user uses browser back/forward buttons.
    if (step.disabled || step.locked) {
      return
    }
    const otherSteps = this.value.filter((_step) => _step.value !== step.value)
    for (const _step of otherSteps) {
      _step.active = false
    }
    step.active = true
    if (this.updateURL && !initial) {
      const currentQuery = this.$route.query['v-step']
      // This condition is to prevent the router from pushing the same query again which triggers the route change watcher
      if (currentQuery !== step.value) {
        this.$router.push({ query: { 'v-step': step.value } })
      }
    }
  }

  getActiveStepIndex(): number {
    let activeStepIdx = 0
    for (let i = 0; i < this.value.length; i++) {
      if (this.value[i].active) {
        activeStepIdx = i
        break
      }
    }
    return activeStepIdx
  }

  nextStep(): void {
    const activeStepIdx = this.getActiveStepIndex()
    for (let i = activeStepIdx + 1; i < this.value.length; i++) {
      const nextStep = this.value[i]
      if (nextStep && !(nextStep.disabled || nextStep.locked)) {
        this.changeStep(nextStep)
        break
      }
    }
  }

  previousStep(): void {
    const activeStepIdx = this.getActiveStepIndex()
    for (let i = activeStepIdx - 1; i >= 0; i--) {
      const nextStep = this.value[i]
      if (nextStep && !(nextStep.disabled || nextStep.locked)) {
        this.changeStep(nextStep)
        break
      }
    }
  }

  created(): void {
    if (this.$route.query['v-step']) {
      const validSteps = this.value.filter((step) => step.value === this.$route.query['v-step'])
      if (validSteps.length === 1) {
        this.changeStep(validSteps[0], true)
      }
    }
  }
}
</script>

<style scoped lang="scss"></style>
